import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './views/Home'
import Artist from './views/Artist'
import Content from './views/Content'
import About from './views/About'
import Contacts from './views/Contacts'
import './App.css'

function App() {
  return (
    <Router>
      <Routes>
        {/* Home page with independent layout */}
        <Route path="/" element={<Home />} />

        {/* Other pages with shared layout */}
        <Route element={<Layout />}>
          <Route path="artist" element={<Artist />} />
          <Route path="content" element={<Content />} />
          <Route path="about" element={<About />} />
          <Route path="contacts" element={<Contacts />} />
        </Route>
      </Routes>
    </Router>
  )
}

export default App
